import { render, staticRenderFns } from "./main-list.vue?vue&type=template&id=270cc828"
import script from "./main-list.vue?vue&type=script&lang=js"
export * from "./main-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports